class NoopExtensionClient {
  async getAdditionalFilters() {
    return [];
  }
  async getCustomMappings() {
    return [];
  }
}

export { NoopExtensionClient };
//# sourceMappingURL=NoopExtensionClient.esm.js.map
